import { AUDIENCE_CARD_TYPE, AudienceCardProps } from '@/types/registration.types';
import Container from '@ui/container/container';
import OptionalComponent from '@ui/optional-component/optional-component';
import AudienceCard from './new-audiences/audience-card';

type AudiencesGridViewProps = {
  isLoading: boolean;
  filteredAudienceCardProps: AudienceCardProps[];
  selectedPasscodeListIds: number[];
  selectedRegistrantLists: AUDIENCE_CARD_TYPE[];
  onCheckboxChange: (checked: boolean, audienceCardType: AUDIENCE_CARD_TYPE, passcodeListId?: number) => void;
  onCreateCampaign: () => void;
};

const AudiencesGridView = ({
  isLoading,
  filteredAudienceCardProps,
  selectedPasscodeListIds,
  selectedRegistrantLists,
  onCheckboxChange,
  onCreateCampaign,
}: AudiencesGridViewProps) => {
  return (
    <Container
      opacity={isLoading ? 0 : 1}
      style={{
        visibility: isLoading ? 'hidden' : 'visible',
        transition: 'opacity 300ms ease-in-out, visibility 300ms ease-in-out',
        pointerEvents: isLoading ? 'none' : 'auto',
      }}
    >
      <Container
        className="grid jc-flex-start ai-center gap-16 radius-8 overflow-hidden"
        style={{
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 320px))',
        }}
      >
        <OptionalComponent display={filteredAudienceCardProps.length > 0}>
          {filteredAudienceCardProps.map((audienceCardProps) => {
            const isSelected =
              audienceCardProps.audienceCardType === AUDIENCE_CARD_TYPE.PASSCODE_LIST
                ? audienceCardProps.passcodeListId !== undefined &&
                  selectedPasscodeListIds.includes(audienceCardProps.passcodeListId)
                : selectedRegistrantLists.includes(audienceCardProps.audienceCardType);
            return (
              <AudienceCard
                key={audienceCardProps.passcodeListId || audienceCardProps.audienceCardType}
                {...audienceCardProps}
                isSelected={isSelected}
                onCheckboxChange={(checked) =>
                  onCheckboxChange(checked, audienceCardProps.audienceCardType, audienceCardProps.passcodeListId)
                }
                onCreateCampaign={onCreateCampaign}
              />
            );
          })}
        </OptionalComponent>
      </Container>
    </Container>
  );
};

export default AudiencesGridView;
